import type {
  CheckboxFilterData,
  CheckboxUpdateFilterEvent,
} from './components/checkboxFilter/CheckboxFilter.model';
import type {
  CircularRadioButtonFilterData,
  CircularRadioButtonUpdateFilterEvent,
} from './components/circularRadioButtonFilter/CircularRadioButtonFilter.model';
import type {
  RadioButtonFilterData,
  RadioButtonUpdateFilterEvent,
} from './components/radioButtonFilter/RadioButtonFilter.model';
import type {
  RangeSliderFilterData,
  RangeSliderUpdateFilterEvent,
} from './components/rangeSliderFilter/RangeSliderFilter.model';
import type {
  SliderFilterData,
  SliderUpdateFilterEvent,
} from './components/sliderFilter/SliderFilter.model';

export const enum FilterType {
  Checkbox = 'Checkbox',
  RadioButton = 'RadioButton',
  CircularRadioButton = 'CircularRadioButton',
  RangeSlider = 'RangeSlider',
  Slider = 'Slider',
}

export const enum FilterUpdateEventType {
  UpdateFilter = 'UpdateFilter',
}

export interface Filter<T> {
  filterType: T;
}

export type FilterTypes =
  | CheckboxFilterData
  | RadioButtonFilterData
  | CircularRadioButtonFilterData
  | RangeSliderFilterData
  | SliderFilterData;

export type FiltersEvents =
  | CheckboxUpdateFilterEvent
  | RadioButtonUpdateFilterEvent
  | CircularRadioButtonUpdateFilterEvent
  | RangeSliderUpdateFilterEvent
  | SliderUpdateFilterEvent;
